import {environment} from '../../../../environments/environment';

export class ViewHelper
{

  public static disableFixedZoom(): void
  {
    this.setViewportContent('width=device-width, initial-scale=1.0');
  }

  public static enableFixedZoom(): void
  {
    this.setViewportContent('width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0');
  }

  private static setViewportContent(content: string): void
  {
    const elementViewport = document.getElementById('meta-viewport');
    console.log('elementViewport: ', elementViewport);
    if (elementViewport)
    {
      elementViewport.setAttribute('content', content);
      console.log('set viewport content: ' + content);
    }
  }

  public static isMobile(): boolean
  {
    return window.screen.width < environment.mobileSize;
  }

  public static stopEvent(event: any): void
  {
    event.originalEvent?.originalEvent?.stopPropagation();
    event.originalEvent?.originalEvent?.preventDefault();
  }
}
